<div class="profile-container">
    <cdk-virtual-scroll-viewport appendOnly itemSize="56">
        <app-profile-info-card></app-profile-info-card>
        <ng-container *ngIf="_GlobalDataService.isAdminAnnonceur()">
            <app-profile-annonceur-card></app-profile-annonceur-card>
        </ng-container>
        <!-- <app-profile-password-card></app-profile-password-card> -->
    </cdk-virtual-scroll-viewport>
</div>